<template>
  <!-- Make a div wrapped slider,set height and width -->
  <div id="mask" @click="isShow">
    <!-- Using the slider component -->
    <slider ref="slider" :options="options">
      <!-- slideritem wrapped package with the components you need -->
      <slideritem
        v-for="(item, index) in someList"
        :key="index"
        :style="item.style"
      >
        <img :src="item.src + '?imageView2/0/format/webp'" alt="" />
      </slideritem>
      <!-- Customizable loading -->
    </slider>
  </div>
</template>
<script>
// import slider components
import { slider, slideritem } from 'vue-concise-slider';
export default {
  props: {
    page: Number,
    isShow: Function,
    someList: Array,
  },
  mounted() {
    document.getElementById('mask').addEventListener('touchmove', function (e) {
      e.preventDefault();
    });
  },
  data() {
    return {
      //data list [array]
      /*      someList:[
          {
            src:require('../assets/intro1.jpg')
          },
          {
            src:require('../assets/intro2.jpg')
          },
          {
        src:require('../assets/intro3.jpg')
          },
           {
        src:require('../assets/intro4.jpg')
          }
        ], */
      //Slider configuration [obj]
      options: {
        currentPage: this.page,
        loop: true,
      },
    };
  },
  methods: {
    dissmiss() {
      this.isShow();
    },
    stop() {
      //
    },
  },
  components: {
    slider,
    slideritem,
  },
};
</script>
<style scoped>
#mask {
  position: fixed;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  z-index: 2000;
  width: 100%;
  height: 100%;
}
img {
  width: 85%;
  border-radius: 1.2rem;
}
</style>
